import React from 'react'
import { withTranslation } from 'react-i18next';
import Parent from '../../common/parent';
import {BllinkLogger} from "../../common/utils/bllink_loggers";
import { constants } from "../../common/constants/constants";
import CacheData from "../../common/utils/cacheData";
import $ from 'jquery';

class ViewBankDetails extends Parent{

    constructor(props) {
        super(props);

        this.fillInDetails.bind(this);
        this.bindBack.bind(this);
        this.buildingID = this.props.match.params.buildingID;
    }

    async componentDidMount(){
        await this.verifyLoggedIn();
        await this.fillInDetails();
        await this.bindApprove();
        await this.bindBack();
    }

    async fillInDetails(){
        const payload = CacheData.fetchCache('BankDetails', {typeOfCache: sessionStorage});
        // todo get from backend by permissions to show to user
        // endpoint is currently just for admins. need to move to managers /bank-details/:buildingID'
        // (also consider retool page https://bllink.retool.com/editor/302ac06c-52be-11ed-af37-035366c66df9/buildings/update%20bank%20details)

        if (payload) {
            this.setState(payload);
            this.fillInDetailsInDom(payload);
        }else{
            // should alert missing details
        }

        // TODO: there is no startLoader pair, consider to remove this
        this.endLoader();
    }

    fillInDetailsInDom(payload){
        let bankDetails = payload.bankDetails;
        $('.js-account-owner').html(payload.fullName);
        $('.js-bank-name').html(bankDetails.bankName);
        $('.js-branch-number').html(bankDetails.branchNumber);
        $('.js-account-number').html(bankDetails.accountID);

    }

    async bindApprove(){
        const {t} = this.props;
        const isAdmin = await this.isAdmin();

        let buildingID = this.props.match.params.buildingID;
        let thisObj = this;
        $('#approve_bank_details').click(async (e)=>{
            e.preventDefault();

            BllinkLogger.info(`posting to new bank details `, thisObj.state);
            thisObj.startLoader();
            const response = await this.client.post(`/managers/buildings/${buildingID}`, thisObj.state);
            if (response.success){
                alert(t('buildings.building_created_message'));
                if (isAdmin) this.props.history.push(`${constants.pages.admin.editBuilding}/${buildingID}`);
                else this.props.history.push(`/${constants.pages.allBuildingsUrl}`);
            }
            thisObj.endLoader();
        })
    }

    async bindBack(){

        let thisObj = this;
        $('#aditing').click((e)=>{
            e.preventDefault();

            thisObj.props.history.push(`/${constants.pages.addBankDetailsUrl}/${thisObj.buildingID}`)
        })
    }

    renderTitle(){

        const {t} = this.props;

        return (
            <section>
                <div className="container">
                    <div className="row">
                        <div className="conf-bnk-d col-md-12">
                            <h2 className="text-center">{t('buildings.new_building_details')}</h2>
                            <p>
                                {t('buildings.opening_building') + ' '} {t('buildings.enable_building_today')}
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        )
    }


    render() {
        const {t} = this.props;

        if (!this.state.userCheck){
            return <div/>
        }

        return (
            <div>
                {this.renderTitle()}
                <section>
                    <div className="container">
                        <div className="col-md-12">
                            <div className="cmf_bank_detail">
                                <form>
                                    <div className="row">
                                        <div className="cmf_from">
                                            <div className="cmf_form_1">
                                                <div className="col-sm-6">
                                                    <div className="form-group">
                                                        <label htmlFor="Email">{t('buildings.bank_account_owner')} </label>
                                                        <p className={'js-account-owner'}>---</p>
                                                    </div>
                                                </div>
                                                <div className="col-sm-6">
                                                    <div className="form-group">
                                                        <label htmlFor="Email">{t('buildings.bank_name')} </label>
                                                        <p className={'js-bank-name'}>---</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="cmf_form_2">
                                                <div className="col-sm-6">
                                                    <div className="form-group">
                                                        <label htmlFor="Email">{t('buildings.branch_number')} </label>
                                                        <p className={'js-branch-number'}>---</p>
                                                    </div>
                                                </div>
                                                <div className="col-sm-6">
                                                    <div className="form-group">
                                                        <label htmlFor="Email">{t('buildings.account_number')} </label>
                                                        <p className={'js-account-number'}>---</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="cmf_bank_btn">
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="form-group cfm_new_btn_1">
                                                    <input type="submit" name="aditing" id="aditing" value={t('buildings.edit')}/>
                                                </div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="form-group cmf_btn_set_2">
                                                    <input type="submit" name="approve" id="approve_bank_details" className={`bllink-button`} value={t('buildings.confirm')}/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}

export default withTranslation()(ViewBankDetails)
